function AboutHeader() {
  return (
    <div className="headerBox">
      <div className="pricingTextBox">
        <h1 className="pricingHeaderText">About</h1>
      </div>
    </div>
  );
}

export default AboutHeader;
